import { render, staticRenderFns } from "./CommonScreenContainer.vue?vue&type=template&id=21152d48&scoped=true"
import script from "./CommonScreenContainer.vue?vue&type=script&lang=js"
export * from "./CommonScreenContainer.vue?vue&type=script&lang=js"
import style0 from "./CommonScreenContainer.vue?vue&type=style&index=0&id=21152d48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21152d48",
  null
  
)

export default component.exports